import React, { useEffect, useMemo, useState } from 'react';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {
    MaterialReactTable,
    useMaterialReactTable,
    type MRT_ColumnDef,
} from 'material-react-table';
// import Image from 'mui-image';
import Breadcrumb from 'src/layouts/full/shared/breadcrumb/Breadcrumb';
import PageContainer from 'src/components/container/PageContainer';
import BlankCard from 'src/components/shared/BlankCard';
import { Course } from 'src/types/course/course';
import axiosServices from 'src/utils/axios';
import { AxiosResponse } from 'axios';
import // IconButton,
    // MenuItem
    '@mui/material';

import {
    //  closeSnackbar,
    useSnackbar,
} from 'notistack';
import Spinner from 'src/views/spinner/Spinner';
import { useParams } from 'react-router-dom';


const BCrumb = [
    {
        to: '/',
        title: 'Home',
    },
    {
        title: 'Payment',
    },
    {
        title: 'Details',
    },
];

const Details = () => {
    const { id } = useParams();
    const { enqueueSnackbar } = useSnackbar();
    const [PaymentDetail, setPaymentDetail] = useState<Course[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const columns = useMemo<MRT_ColumnDef<Course>[]>(
        () => [
            {
                accessorKey: 'id', //access nested data with dot notation
                header: 'id',
                size: 150,
            },

            {
                accessorKey: 'course_name', //normal accessorKey
                header: 'Course Name',
                size: 200,
            },
            {
                accessorKey: 'amount',
                header: 'Course Amount',
                size: 150,
            },
        ],
        [],
    );

    const table = useMaterialReactTable({
        columns,
        data: PaymentDetail,
        state: { isLoading: loading },
        positionActionsColumn: 'last',
        enableRowActions: false,
    });

    const getPayment = async () => {
        setLoading(true);
        try {
            const response: AxiosResponse = await axiosServices.get(`/teacher/payment/view`);
            console.log(response, "response")
            setLoading(false);
            const payemntDetail = response.data.data?.find((e:any)=>e?.id === Number(id))
            setPaymentDetail(payemntDetail?.user_payments)
        } catch (error: any) {
            setLoading(false);
            if (error.response) {
                // This is an Axios error with a response object
                enqueueSnackbar(error.response.data.message, { variant: 'error' });
                // closeSnackbar(snackbarId);
            } else {
                // This is a general error
                enqueueSnackbar(error.message, { variant: 'error' });
                // closeSnackbar(snackbarId);
            }
        }
    };

    useEffect(() => {
        getPayment();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    if (loading) {
        return <Spinner />;
    }

    return (
        <PageContainer title="All Payment Details" description="All Payment Details">
            {/* breadcrumb */}
            <Breadcrumb title="Payment Details" items={BCrumb} />
            <BlankCard>
                {/* ------------------------------------------- */}
                {/* Left part */}
                {/* ------------------------------------------- */}

                <MaterialReactTable table={table} />
            </BlankCard>
        </PageContainer>
    );
};

export default Details;

